var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('c-header'),_c('router-view',{key:new Date().getTime()}),_c('c-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }